var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirtime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.21216 18.7881C1.46313 15.0391 1.46313 8.96071 5.21217 5.21168C7.5821 2.84174 10.8829 1.96995 13.9376 2.5963M19.7396 6.31751C22.505 10.0741 22.188 15.3887 18.7886 18.7881C16.3431 21.2336 12.9064 22.0839 9.77169 21.339M17.8377 7.86043V4.26043L21.4377 4.26043L17.8377 7.86043ZM6.06008 16.0366V19.6366H2.46008L6.06008 16.0366Z",
    stroke: "#6882B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirtime);
export default __webpack_public_path__ + "static/media/airtime.65c5fdf70a6616ffbc4d017b04dd8911.svg";
export { ForwardRef as ReactComponent };